<template>
    <div class="el-form-card">
        <div class="el-form-card__header">
            {{ formText }} {{ $t('form.title.user') }}
        </div>
        <div class="el-form-card__body dark-form__light-overlay" v-loading="loading">
            <el-form
                ref="form"
                class="dark-form"
                :model="form"
                :rules="rules"
                size="mini"
                label-position="top"
                label-width="125px"
            >
                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="firstName">
                            <v-text-field
                                :label="$t('form.label.firstName')"
                                v-model="form.firstName"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="lastName">
                            <v-text-field
                                :label="$t('form.label.lastName')"
                                v-model="form.lastName"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="username">
                            <v-text-field
                                :label="$t('form.label.email')"
                                v-model="form.username"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="phone">
                            <v-text-field
                                :label="$t('form.label.phone')"
                                v-model="form.phone"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="company">
                            <v-text-field
                                :label="$t('form.label.company')"
                                v-model="form.company"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper" v-if="editing">
                        <el-form-item prop="newPassword">
                            <stc-password
                                labelText="Password"
                                v-model="form.newPassword"
                                fetch-url="Util/GeneratePassword"
                                :onLoadGenerate="true"
                            ></stc-password>
                        </el-form-item>
                    </div>
                    <div class="el-form-card__element-wrapper" v-else>
                        <el-form-item prop="password">
                            <stc-password
                                :labelText="$t('form.label.password')"
                                v-model="form.password"
                                fetch-url="Util/GeneratePassword"
                                :onLoadGenerate="true"
                            ></stc-password>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row v-if="permissions.includes('SUPER_USER')">
                    <div
                        class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                    >
                        <el-form-item prop="allowGates">
                            <div class="el-checkbox-list">
                                <v-checkbox
                                    :label="$t('form.label.allowGates')"
                                    v-model="form.allowGates"
                                    color="success"
                                    hide-details
                                >
                                </v-checkbox>
                            </div>
                        </el-form-item>
                    </div>
                </el-row>

                <div class="form-expanded-content" v-if="form.allowGates">
                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item prop="pinCode" class="form-element">
                                <stc-password
                                    :labelText="$t('form.label.pinCode')"
                                    readonly
                                    v-model="form.pinCode"
                                    fetch-url="Util/GeneratePin"
                                    :onLoadGenerate="true"
                                >
                                </stc-password>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div
                            class="el-form-card__element-wrapper el-form-card__element-wrapper"
                        >
                            <el-form-item prop="allowApp">
                                <div
                                    class="el-checkbox-list el-checkbox-list--top-gap"
                                >
                                    <v-checkbox
                                        :label="$t('form.label.allowApp')"
                                        v-model="form.allowApp"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item prop="schedule">
                                <v-select
                                    :items="schedules"
                                    :label="$t('form.label.selectSchedule')"
                                    v-model="form.schedule"
                                    item-value="Description"
                                    item-text="Description"
                                    return-object
                                    clearable
                                    multiple
                                    required
                                    chips
                                    dark
                                >
                                </v-select>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row v-if="form.schedule.length && gates.length">
                        <div
                            class="el-form-card__element-wrapper input-group pt-2"
                        >
                            <label class="body-2">{{
                                $t('form.label.gates')
                            }}</label>
                        </div>
                    </el-row>

                    <el-row v-if="form.schedule.length && gates.length">
                        <div class="el-form-card__element-wrapper">
                            <stc-scheduled-gate-access
                                v-for="schedule in form.schedule"
                                :key="schedule.ScheduleTemplateID"
                                :scheduled-gates="
                                    form.scheduledGates[
                                        schedule.ScheduleTemplateID
                                    ]
                                "
                                :schedule="schedule"
                                :gates="gates"
                                @gates-scheduled="handleScheduledGates"
                            >
                            </stc-scheduled-gate-access>
                        </div>
                    </el-row>

                    <el-row v-if="selectedContainer.AutoPinEnabled">
                        <div
                            class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                        >
                            <el-form-item prop="isAdvance">
                                <div class="el-checkbox-list">
                                    <v-checkbox
                                        :label="$t('form.label.advancedSettings')"
                                        v-model="form.isAdvance"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>
                        </div>
                    </el-row>

                    <div class="el-form-card__element-wrapper" v-if="form.isAdvance">
                        <el-form-item prop="autoPinChangeInterval">
                            <v-text-field
                                :label="$t('form.label.autoPinChangeInterval')"
                                v-model="form.autoPinChangeInterval"
                            ></v-text-field>
                        </el-form-item>
                        <el-form-item prop="autoPinNotificationRecipient">
                            <v-text-field
                                :label="$t('form.label.autoPinNotification')"
                                v-model="form.autoPinNotificationRecipient"
                            ></v-text-field>
                        </el-form-item>
                    </div>

                </div>

                <el-row
                    class="pb-3 pt-1"
                    v-if="permissions.includes('SUPER_USER')"
                >
                    <div class="el-form-card__element-wrapper">
                        <div
                            slot="header"
                            class="clearfix text-xs-left mb-0 input-group"
                        >
                            <label><strong>{{ $t('form.label.unloadingArea') }}</strong></label>
                        </div>
                        <el-form-item prop="containerPermissions">
                            <div>
                                <v-select
                                    :items="unloadingAreasContainers"
                                    :label="
                                        $t('form.label.selectUnloadingArea')
                                    "
                                    v-model="form.containerPermissions"
                                    item-value="ContainerID"
                                    item-text="Description"
                                    clearable
                                    multiple
                                    required
                                    chips
                                    dark
                                >
                                </v-select>
                            </div>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="comment">
                            <v-text-field
                                :label="
                                    $t('form.label.additionalInformation')
                                "
                                v-model="form.comment"
                                multi-line
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <div
                            class="el-checkbox-list el-checkbox-list--bottom-gap el-checkbox-list--top-gap"
                            prop="permissions"
                        >
                            <v-checkbox
                                v-if="
                                    permissions.includes(
                                        'SCHEDULETEMPLATE_READ'
                                    )
                                "
                                :label="
                                    $t('form.label.allowUserManageSchedules')
                                "
                                v-model="form.permissions"
                                value="SCHEDULETEMPLATE_WRITE,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                            <v-checkbox
                                v-if="permissions.includes('ACTOR_WRITE')"
                                :label="$t('form.label.permission.manage')"
                                v-model="form.permissions"
                                value="ACTOR_WRITE,ACTOR_DELETE"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                            <v-checkbox
                                v-if="permissions.includes('SUPPLIER_MANAGE')"
                                :label="$t('form.label.permission.supplier-manage')"
                                v-model="form.permissions"
                                value="SUPPLIER_MANAGE"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                            <v-checkbox
                                v-if="permissions.includes('USER_WRITE')"
                                :label="$t('form.label.permission.access')"
                                v-model="form.permissions"
                                value="USER_WRITE,USER_DELETE"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                            <v-checkbox
                                v-if="permissions.includes('BLC_READ')"
                                :label="$t('form.label.permission.blc')"
                                v-model="form.permissions"
                                value="BLC_READ,BLC_WRITE,VEHICLE_READ,ACTOR_WRITE"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                            <v-checkbox
                                v-if="permissions.includes('SUPER_USER')"
                                :label="$t('form.label.superUserPermissions')"
                                v-model="form.permissions"
                                value="SUPER_USER"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                        </div>
                    </div>
                </el-row>
                <div class="button-wrapper flex justify-between items-center">
                    <v-btn
                        round
                        color="primary"
                        @click="submit"
                        :disabled="loading"
                        dark
                    >{{ formText }}</v-btn
                    >
                    <v-btn round color="dark" @click="reset" dark>{{
                        $t('form.button.cancel')
                    }}</v-btn>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import StcPassword from '../Password'
import { mapGetters, mapActions } from 'vuex'
import ScheduledGateAccess from './ScheduledGateAccess'
import InteractWithActor from '../../mixins/interact-with-actor'
import InteractWithSchedules from '../../mixins/interact-with-schedules'

export default {
    name: 'user-create',

    data() {
        return {
            editing: false,
            loading: false,
            user: '',
            containers: [],
            unloadingAreas: [],
            actor: {
                ActorID: '',
            },
            gates: [],
            form: {
                culture: 'sv-SE',
                username: '',
                phone: '',
                company: '',
                password: '',
                newPassword: '',
                firstName: '',
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                lastName: '',
                containerPermissions: [],
                autoPinChangeInterval: '',
                autoPinNotificationRecipient: '',
                permissions: [
                    'SUPPLIER_VIEW,UNLOADINGAREA_READ,CHECKPOINT_READ,UTIL_READ,CONTAINER_READ,USER_READ,SCHEDULETEMPLATE_READ,ACTOR_READ',
                ],
                comment: '',
                pinCode: '',
                schedule: [],
                gates: [],
                scheduledGates: {},
                allowGates: false,
                allowApp: false,
                isAdvance: false,
            },
        }
    },

    created() {
        this.fetchGates()
        this.fetchContainers()
        this.fetchUnloadingAreas()
    },

    mounted() {
        this.form.company = this.me.Company

        Events.$on('user-editing', async data => {
            this.loading = true

            if (this.$refs.form) {
                await this.$refs.form.resetFields()
            }
            this.resetPermissions()
            this.editing = true

            this.user = data
            this.fillFormUser(this.user)
            this.fillFormUserPermissions()

            if (data['RelatedActorID']) {
                this.actor = await this.fetchActorByID(data['RelatedActorID'])
                this.actor.AccessSets.forEach(accessSet => {
                    this.fillFormAccessSet(accessSet)
                })
                this.fillFormActor(this.actor)

                let autoPinData = await this.fetchAutoPinData(
                    data['RelatedActorID']
                )
                this.fillFormAutoPin(autoPinData)
            }

            this.loading = false
        })
    },

    mixins: [InteractWithActor, InteractWithSchedules],

    components: {
        'stc-password': StcPassword,
        'stc-scheduled-gate-access': ScheduledGateAccess,
    },

    watch: {
        'form.allowGates': function(allowGates) {
            if (!allowGates) {
                this.form.gates = []
                this.form.pinCode = ''
                this.form.schedule = []
                this.form.comment = ''
                this.form.allowApp = false
                this.form.scheduledGates = {}
            }
        },

        'form.allowApp': function(allow) {
            if (allow) {
                this.form.permissions.push(
                    'CHECKPOINT_OPEN,JOB_READ,CHECKPOINT_WRITE,SCHEDULETEMPLATE_READ'
                )
            } else {
                const index = this.form.permissions.indexOf(
                    'CHECKPOINT_OPEN,JOB_READ,CHECKPOINT_WRITE,SCHEDULETEMPLATE_READ'
                )
                this.form.permissions.splice(index, 1)
            }
        },

        'form.schedule': function(newVal, oldVal) {
            const diff = _.difference(oldVal, newVal)

            diff.forEach(item =>
                Vue.delete(this.form.scheduledGates, item.ScheduleTemplateID)
            )
        },

        selectedContainer() {
            if (this.editing) {
                this.reset()
            }
        },
    },

    computed: {
        ...mapGetters(['permissions', 'selectedContainer']),

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },

        me() {
            return this.$auth.user()
        },

        actionList() {
            let actionList = []

            this.form.permissions.forEach(action => {
                let actions = action.split(',')

                actions.forEach(action => {
                    actionList.push(action)
                })
            })

            return _.uniq(actionList)
        },

        userPayload() {
            let permissions = []

            this.form.containerPermissions.forEach(containerId => {
                permissions.push({
                    ContainerID: containerId,
                    Permission: 'UNLOADINGAREA_READ',
                })
                permissions.push({
                    ContainerID: containerId,
                    Permission: 'ACTOR_READ',
                })
                permissions.push({
                    ContainerID: containerId,
                    Permission: 'ACTOR_WRITE',
                })
            })

            this.actionList.forEach(action => {
                permissions.push({
                    ContainerID: this.selectedContainer.ContainerID,
                    Permission: action,
                })
            })

            return {
                UserName: this.form.username,
                Password: this.form.password,
                FirstName: this.form.firstName,
                LastName: this.form.lastName,
                Company: this.form.company,
                Phone: this.form.phone,
                Culture: this.form.culture,
                RelatedActorID: this.actor.ActorID,
                Permissions: permissions,
                ContainerID: this.selectedContainer.ContainerID,
            }
        },

        actorPayload() {
            this.form.recipientPhone = this.form.phone
            this.form.recipientCompany = this.form.company
            this.form.recipientName = `${this.form.firstName} ${
                this.form.lastName
            }`

            return {
                ActorType: 'STANDARD',
                Email: this.form.username,
                FirstName: this.form.firstName,
                LastName: this.form.lastName,
                MAIsEnabled: this.form.allowApp,
                Comment: this.form.comment,
                Company: this.form.company,
                Phone: this.form.phone,
                PinCode: this.form.pinCode,
                LocationValidationDisabled: true,
                AccessSets: this.buildAccessSet(this.form),
            }
        },

        rules() {
            const rules = {
                username: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: this.$t('form.validation.valid', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur,change',
                    },
                ],
                firstName: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.firstName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.phone'),
                        }),
                        trigger: 'blur',
                    },
                ],
                company: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.company'),
                        }),
                        trigger: 'blur',
                    },
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.lastName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.password'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        min: 8,
                        message: this.$t(
                            'form.validation.minNumberCharacters',
                            {
                                name: this.$t('form.label.password'),
                                number: 8,
                            }
                        ),
                        trigger: 'blur,change',
                    },
                ],
                pinCode: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.pinCode'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: this.$t('form.validation.minNumberDigits', {
                            name: this.$t('form.label.pinCode'),
                            number: 6,
                        }),
                        trigger: 'blur,change',
                    },
                ],
                schedule: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.selectSchedule'),
                        }),
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },

        unloadingAreasContainers() {
            const containerIds = _.map(this.unloadingAreas, 'ContainerID')

            const containers = this.containers.filter(container => {
                return containerIds.some(id => id === container.ContainerID)
            })

            return _.uniq(containers, 'ContainerID')
        },
    },

    methods: {
        handleScheduledGates({ schedule, gates }) {
            if (!gates.length) {
                Vue.delete(
                    this.form.scheduledGates,
                    schedule.ScheduleTemplateID
                )
            } else {
                Vue.set(
                    this.form.scheduledGates,
                    schedule.ScheduleTemplateID,
                    gates
                )
            }
        },

        resetPermissions() {
            let permissions = []

            permissions.push(
                'SUPPLIER_VIEW,UNLOADINGAREA_READ,CHECKPOINT_READ,UTIL_READ,CONTAINER_READ,USER_READ,SCHEDULETEMPLATE_READ,ACTOR_READ'
            )

            this.form.permissions = permissions
        },

        reset() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.resetPermissions()

            this.form.company = this.me.Company

            this.actor = {
                ActorID: '',
            }
            this.user = ''
            this.editing = false
        },

        fillFormUser(user) {
            this.form.username = user.UserName
            this.form.firstName = user.FirstName
            this.form.lastName = user.LastName
            this.form.company = user.Company
            this.form.phone = user.Phone
            this.form.culture = user.Culture || this.form.culture
            this.form.containerPermissions = _.uniq(
                _.map(user.Permissions, 'ContainerID')
            )
        },

        async fillFormUserPermissions() {
            const permissions = _.map(this.user.Permissions, 'Permission')

            if (_.includes(permissions, 'ACTOR_WRITE')) {
                this.form.permissions.push('ACTOR_WRITE,ACTOR_DELETE')
            }

            if (_.includes(permissions, 'USER_WRITE')) {
                this.form.permissions.push('USER_WRITE,USER_DELETE')
            }

            if (_.includes(permissions, 'BLC_READ')) {
                this.form.permissions.push(
                    'BLC_READ,BLC_WRITE,VEHICLE_READ,ACTOR_WRITE'
                )
            }

            if (_.includes(permissions, 'CONTAINER_WRITE')) {
                this.form.permissions.push('CONTAINER_WRITE')
            }

            if (_.includes(permissions, 'SCHEDULETEMPLATE_WRITE')) {
                this.form.permissions.push(
                    'SCHEDULETEMPLATE_WRITE,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ'
                )
            }

            if (_.includes(permissions, 'SUPPLIER_MANAGE')) {
                this.form.permissions.push('SUPPLIER_MANAGE')
            }

            if (_.includes(permissions, 'SUPER_USER')) {
                this.form.permissions.push('SUPER_USER')
            }

            const serverPermissions = _.difference(permissions, this.actionList)

            if (serverPermissions.length) {
                this.form.permissions = [
                    ...this.form.permissions,
                    ...serverPermissions,
                ]
            }
        },

        fillFormActor(actor) {
            this.form.allowApp = actor.MAIsEnabled
            this.form.pinCode = actor.PinCode || ''
            this.form.comment = actor.Comment || ''
            this.form.allowGates = true
        },

        fillFormAutoPin(data) {
            this.form.autoPinChangeInterval = data.ChangeInterval
            this.form.autoPinNotificationRecipient = data.NotificationRecipient
            this.form.isAdvance =
                data.ChangeInterval || data.NotificationRecipient
        },

        fillFormAccessSet(accessSet) {
            const gate = _.find(this.gates, {
                CheckpointID: accessSet['CheckPointID'],
            })

            accessSet.ScheduleTemplates.forEach(schedule => {
                schedule = _.find(this.schedules, {
                    ScheduleTemplateID: schedule['ScheduleTemplateID'],
                })

                if (!this.form.scheduledGates[schedule.ScheduleTemplateID]) {
                    Vue.set(
                        this.form.scheduledGates,
                        schedule.ScheduleTemplateID,
                        []
                    )
                }

                if (!this.form.schedule.includes(schedule)) {
                    this.form.schedule.push(schedule)
                }

                if (
                    !this.form.scheduledGates[
                        schedule.ScheduleTemplateID
                    ].includes(gate)
                ) {
                    this.form.scheduledGates[schedule.ScheduleTemplateID].push(
                        gate
                    )
                }
            })
        },

        async submit() {
            this.loading = true

            try {
                await this.$refs.form.validate()

                if (this.form.allowGates) {
                    if (this.actor.ActorID) {
                        this.$http.put(
                            `Actor/${this.actor.ActorID}`,
                            this.actorPayload
                        )
                    } else {
                        let { data } = await this.$http.post(
                            'Actor',
                            this.actorPayload
                        )
                        this.actor.ActorID = data
                    }
                } else {
                    if (this.actor.ActorID) {
                        this.$http.delete(`Actor/${this.actor.ActorID}`)
                        this.actor = {
                            ActorID: '',
                        }
                    }
                }

                if (this.form.isAdvance && this.actor.ActorID) {
                    this.$http.post(`Actor/${this.actor.ActorID}/AutoPin`, {
                        NotificationRecipient: this.form
                            .autoPinNotificationRecipient,
                        ChangeInterval: this.form.autoPinChangeInterval,
                    })
                } else {
                    if (this.actor.ActorID) {
                        this.$http.post(`Actor/${this.actor.ActorID}/AutoPin`, {
                            NotificationRecipient: '',
                            ChangeInterval: 0,
                        })
                    }
                }

                let method = this.editing ? 'put' : 'post'
                let url = this.editing ? `User/${this.user.UserID}` : 'User'

                await this.$http[method](url, this.userPayload)

                if (this.editing) {
                    if (this.form.newPassword.length) {
                        this.$http.post(
                            `User/${this.user.UserID}/SetPassword/${
                                this.form.newPassword
                            }`
                        )
                    }
                }

                if (this.user && this.user.UserID === this.me.UserID) {
                    this.fetchContainerPermissions()
                    let { data } = await this.$auth.fetch()

                    this.$auth.user(data)
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.user'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.user'),
                          }),
                })

                this.notifyUserUpdate()
                this.reset()
            } catch (e) {
                if (e === false) {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e.response.data}.`,
                    })
                }
            }

            this.loading = false
        },

        notifyUserUpdate() {
            Events.$emit('user-updated')
        },

        async fetchGates(container = null) {
            container = container || this.selectedContainer

            if (this.permissions.includes('CHECKPOINT_READ') && container) {
                let { data } = await this.$http.get(`Checkpoint`)
                data.sort( (a, b) => {
                    if(a && b && a.Name && b.Name){
                        return a.Name.localeCompare(b.Name, 'en', {numeric: true})
                    }          
                });
                this.gates = data
            }
        },

        async fetchContainers() {
            let { data } = await this.$http.get('Container')

            this.containers = data
        },

        async fetchUnloadingAreas() {
            let { data } = await this.$http.get('UnloadingArea')
            data.sort( (a, b) => {
                if(a && b && a.Description && b.Description){
                    return a.Description.localeCompare(b.Description, 'en', {numeric: true})
                }          
            });
            this.unloadingAreas = data
        },

        async fetchAutoPinData(actorId) {
            let { data } = await this.$http.get(`Actor/${actorId}/AutoPin`)

            return data
        },

        ...mapActions(['fetchContainerPermissions']),
    },
}
</script>

<style lang="scss" scoped>
.cell {
    .el-form-item--mini {
        margin-bottom: 0 !important;
    }
}
</style>
